import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const NoResults = styled.div`
  margin-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  align-items: center;
  text-align: center;
  top: 13.18%;
`;

export const NoResultText = styled(Text.Small)`
  font-style: normal;
  color: ${({ theme }) => theme.yoga.colors.textDisabled};
`;
